import { createSlice } from "@reduxjs/toolkit";

import { type OnboardingStepsStateType } from "../interfaces";

const initialState: OnboardingStepsStateType = {
  isLoading: false,
  onboardingSteps: [],
};

const onboardingStepsSlice = createSlice({
  name: "onboardingSteps",
  initialState,
  reducers: {
    setOnboardingStepsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setOnboardingSteps: (state, action) => {
      state.onboardingSteps = action.payload;
    },
  },
});

export const { setOnboardingStepsLoading, setOnboardingSteps } =
  onboardingStepsSlice.actions;
export default onboardingStepsSlice.reducer;
